import { FC, ReactNode, useCallback } from 'react'

import { AnyAptosWallet, isInstallRequired } from '@aptos-labs/wallet-adapter-core'
import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { CHAIN_ID } from 'config'

import { WalletItem } from 'components/WalletItem'
import { cx } from 'utils/cx.ts'

import s from './s.module.scss'

type Props = {
  isPontem?: boolean
  onClose: () => void
  onConnect?: () => void
  wallet: AnyAptosWallet
}

type PropsConnectButton = {
  children: ReactNode
  connectWallet: () => void
}
type PropsInstallLink = {
  children: ReactNode
  url: string
}

const ConnectButton: FC<PropsConnectButton> = ({ children, connectWallet }) => (
  <div onClick={connectWallet}>{children}</div>
)

const InstallLink: FC<PropsInstallLink> = ({ children, url }) => (
  <a className={s.link} href={url} rel="noopener noreferrer" target="_blank">
    {children}
  </a>
)

const WalletWrapperItem: FC<Props> = ({ isPontem, onClose, onConnect, wallet: walletItem }) => {
  const { connect, disconnect, wallet: activeWallet } = useWallet()

  const connectWallet = useCallback(async () => {
    try {
      if (
        walletItem.name.toLowerCase().includes('pontem') &&
        window.pontem?._client?._rpcClient?._options?.streamName === 'pontem-external'
      ) {
        await window.pontem.switchNetwork(CHAIN_ID)
      }

      if (walletItem.name === activeWallet?.name) {
        await disconnect()
      }
      console.log('connectWallet', walletItem.name)
      await connect(walletItem.name)

      onConnect?.()
      onClose()
    } catch (e) {
      console.log('connectWallet', e)
    }
  }, [])

  const isInstall = isInstallRequired(walletItem)

  return (
    <li className={cx(s.itemWrapper, `${walletItem.readyState}`)} key={walletItem.name}>
      {!isInstall && (
        <ConnectButton connectWallet={connectWallet}>
          <WalletItem isPontem={isPontem} wallet={walletItem} />
        </ConnectButton>
      )}
      {isInstall && (
        <InstallLink url={walletItem.url}>
          <WalletItem isPontem={isPontem} wallet={walletItem} />
        </InstallLink>
      )}
    </li>
  )
}

export default WalletWrapperItem
